import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GapiPickerService } from 'src/app/_services/gapi-picker';
import { MatStepper, MatStep } from '@angular/material/stepper';

@Component({
  selector: 'app-compartir-rubrica-classroom',
  standalone: false,
  templateUrl: './compartir-rubrica-classroom.component.html',
  styleUrls: ['./compartir-rubrica-classroom.component.scss']
})
export class CompartirRubricaClassroomComponent {

  data: any;
  cargandoSpreadsheet: boolean;

  @ViewChild('step', {static: true}) firstStep: MatStep;
  @ViewChild('step2', {static: true}) secondStep: MatStep;
  @ViewChild('stepperDialog', {static: true}) stepperControl: MatStepper;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataInject: any,
    private gapiPickerService: GapiPickerService,
    private ref: ChangeDetectorRef
    ) {
      this.data = dataInject;
      this.gapiPickerService.getPickerServiceObservable().subscribe(data => {
        if (!data) {
            return false;
        }

        if (data.tipo === 'cargar-boton-classroom') {
            this.cargandoSpreadsheet = false;
            this.gapiPickerService.createClassRoomButton('widget-div-dialog', data.url);
            this.firstStep.completed = true;
            this.stepperControl.next();
            this.ref.detectChanges();
        }
    });
    }

  crearSpreadsheet(stepper) {
    this.cargandoSpreadsheet = true;
    this.gapiPickerService.initSpreadsheet(this.data);
  }
}
